/**
 * @generated SignedSource<<1841da18284218c0a27a3ce3dd53bb4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AppBuildState = "DISABLED" | "PENDING_BRAND_SETUP" | "PENDING_KINN_SETUP" | "PRE_PRODUCTION" | "PRODUCTION" | "%future added value";
export type DuplicateBrandInput = {
  androidAppIdentifier?: string | null;
  displayName?: string | null;
  iosAppIdentifier?: string | null;
  sourceBrandId: string;
  targetBrandId?: string | null;
};
export type useDuplicateBrandMutation$variables = {
  input: DuplicateBrandInput;
};
export type useDuplicateBrandMutation$data = {
  readonly duplicateBrand: {
    readonly brand: {
      readonly androidPushNotificationRequiresFcmv1Migration: boolean;
      readonly appConfig: {
        readonly androidAppIdentifier: string;
        readonly appState: AppBuildState;
        readonly iosAppIdentifier: string;
      };
      readonly appleDeveloperAgreementsPendingSince: any | null;
      readonly displayName: string;
      readonly facebookConfig: {
        readonly id: string;
        readonly needsReauth: boolean;
      } | null;
      readonly id: string;
      readonly iosPushNotificationCredentialsRequireServiceKeyMigration: boolean;
      readonly isBrandAdmin: boolean;
      readonly showIosTosAlert: boolean;
      readonly tempoApiToken: string | null;
    };
  };
};
export type useDuplicateBrandMutation = {
  response: useDuplicateBrandMutation$data;
  variables: useDuplicateBrandMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isBrandAdmin",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLFacebookClientConfig",
  "kind": "LinkedField",
  "name": "facebookConfig",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "needsReauth",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appleDeveloperAgreementsPendingSince",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showIosTosAlert",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tempoApiToken",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iosPushNotificationCredentialsRequireServiceKeyMigration",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "androidPushNotificationRequiresFcmv1Migration",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appState",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iosAppIdentifier",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "androidAppIdentifier",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDuplicateBrandMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DuplicateBrandResult",
        "kind": "LinkedField",
        "name": "duplicateBrand",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandType",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandAppConfigType",
                "kind": "LinkedField",
                "name": "appConfig",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDuplicateBrandMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DuplicateBrandResult",
        "kind": "LinkedField",
        "name": "duplicateBrand",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandType",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandAppConfigType",
                "kind": "LinkedField",
                "name": "appConfig",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f51f06846807e62a3fd54a46b74ebaed",
    "id": null,
    "metadata": {},
    "name": "useDuplicateBrandMutation",
    "operationKind": "mutation",
    "text": "mutation useDuplicateBrandMutation(\n  $input: DuplicateBrandInput!\n) {\n  duplicateBrand(input: $input) {\n    brand {\n      id\n      isBrandAdmin\n      displayName\n      facebookConfig {\n        id\n        needsReauth\n      }\n      appleDeveloperAgreementsPendingSince\n      showIosTosAlert\n      tempoApiToken\n      iosPushNotificationCredentialsRequireServiceKeyMigration\n      androidPushNotificationRequiresFcmv1Migration\n      appConfig {\n        appState\n        iosAppIdentifier\n        androidAppIdentifier\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "acb9d1498e9dd87d886b5554fd65e69a";

export default node;
